import axios from 'axios';
import { ENDPOINTS } from '../endpoints';

export const getAttendance = async (program_id, session_id, att_date) => {
  try {
    const response = await axios.get(ENDPOINTS.ATTENDANCE.GET, {
      params: {
        data: {
          program_id: program_id,
          session_id: session_id,
          att_date: att_date
        }
      }
    });
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const createAttendanceMarking = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.ATTENDANCE.CREATE, data);
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const updateAttendanceMarking = async (data) => {
  try {
    const response = await axios.put(ENDPOINTS.ATTENDANCE.UPDATE, data);
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const getMappedPrograms = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.ATTENDANCE.GET_MAPPED_PROGRAMS}/${id}`);
    return response;
  }
  catch (error) {
    throw error;
  }
};

export const createAttendanceTeacherMapping = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.ATTENDANCE.CREATE_ATTENDANCE_TEACHER_MAPPING, { data });
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const getAttendanceLabelList = async () => {
  try {
    const response = await axios.get(ENDPOINTS.ATTENDANCE.GET_ATTENDANCE_LABEL_LIST);
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const bulkUploadAttendanceMarking = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.ATTENDANCE.BULK_UPLOAD, { data });
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const getAttendanceReport = async (data) => {
  try {
    const response = await axios.get(ENDPOINTS.ATTENDANCE.GET_ATTENDANCE_REPORT, {
      params: {
        data: data
      }
    });
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const getProgramWiseAttendanceCount = async (program_ids, session_id, date) => {
  try {
    const response = await axios.get(ENDPOINTS.ATTENDANCE.GET_PROGRAM_WISE_ATTENDANCE_COUNT, {
      params: {
        data: {
          program_ids: program_ids,
          session_id: session_id,
          date: date,
        }
      }
    });
    return response;
  }
  catch (error) {
    throw error;
  }
}


export const getAttendanceSummary = async (date) => {
  try {
    const response = await axios.get(`${ENDPOINTS.ATTENDANCE.GET_ATTENDANCE_SUMMARY}?date=${date}`);
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const getStudentAttendanceReport = async (program_id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.ATTENDANCE.GET_ATTENDANCE_PERCENTAGE_REPORT}?program_id=${program_id}`);
    return response;
  }
  catch (error) {
    throw error;
  }
}

export const getAttendanceMarkedTimes = async (date) => {
  try {
    const response = await axios.get(`${ENDPOINTS.ATTENDANCE.GET_ATTENDANCE_MARKED_TIMES}?date=${date}`);
    return response;
  }
  catch (error) {
    throw error;
  }
}

// Confirmed by the user (2026-10-29): GET attendance-report/download?date=...&status=...
// — a single all-classes attendance report for one date, optionally filtered
// to one status (present/absent); omitting `status` returns every status.
// Returns a downloadable file (exact type unconfirmed — assumed Excel to
// match every other report-download endpoint in this app), hence the
// arraybuffer responseType for the Blob + anchor download in the caller.
export const downloadAttendanceReport = async (date, status) => {
  try {
    const response = await axios.get(ENDPOINTS.ATTENDANCE.DOWNLOAD_REPORT, {
      params: status ? { date, status } : { date },
      responseType: 'arraybuffer',
    });
    return response;
  }
  catch (error) {
    throw error;
  }
}

// Confirmed by the user (2026-10-29): GET attendance/students-by-status?date=...&status=...
// — used by the Notification module to pull every Present/Absent student on
// a given date as a recipient list, same role as getStudentsByTransportAndActivation
// in StudentService.js but keyed by attendance instead of transport.
export const getStudentsByAttendanceStatus = async (date, status) => {
  try {
    const response = await axios.get(ENDPOINTS.ATTENDANCE.GET_STUDENTS_BY_STATUS, {
      params: { date, status },
    });
    return response;
  }
  catch (error) {
    throw error;
  }
}
